import { createFileRoute } from '@tanstack/react-router'
import { calendarRepository } from '@/data/adapters/api/calendar.api'

export const Route = createFileRoute('/$orgSlug/$clientSlug/campaign-report/$campaignId')({
  loader: ({ context: { queryClient, org, client } }) =>
    queryClient.ensureQueryData({
      queryKey: ['calendar', 'events', org.id, client.id],
      queryFn: () => calendarRepository.getEvents(org.id, client.id),
    }),
})
